export default "__VITE_ASSET__DQ745FA9__"